// Display-only live values (04 §2.2): counters animate from amounts, rates, caps and evaluatedAt
// between server responses; the next response or event replaces them.
import type { ResourceBlock, Resources } from '@stars-and-ships/api-types';
import { useEffect, useState } from 'react';

const HOUR_MS = 3_600_000;

/** The current time, re-rendering every `intervalMs`. */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

export function liveAmount(
  amount: number,
  ratePerHour: number,
  cap: number,
  evaluatedAt: string,
  now: number
): number {
  if (amount >= cap) return amount;
  const elapsed = Math.max(0, now - Date.parse(evaluatedAt));
  return Math.min(cap, Math.floor(amount + (ratePerHour * elapsed) / HOUR_MS));
}

export function liveResources(block: ResourceBlock, now: number): Resources {
  const one = (key: keyof Resources) =>
    liveAmount(
      block.amounts[key],
      block.ratesPerHour[key],
      block.caps[key],
      block.evaluatedAt,
      now
    );
  return { metal: one('metal'), gas: one('gas'), supplies: one('supplies') };
}

export const affordable = (have: Resources, cost: Resources): boolean =>
  have.metal >= cost.metal && have.gas >= cost.gas && have.supplies >= cost.supplies;
